module.exports = __webpack_public_path__ + "static/media/mpl-qr-footer.239158a2.jpg";